(function(w, d) {
    var webauthn = {
        init: function () {
            if (TNCMS.User.hasWebauthnCredential()) {
                var btn = d.getElementById('webauthnLogin'),
                    webauthUI = d.querySelectorAll('.webauthn-ui');
                
                if (btn) {
                    /** Link button to webauthn */
                    btn.addEventListener("click", function(ev) {
                        ev.preventDefault();
                        
                        // Prevent duplicate attempts
                        btn.disabled = true;
                        
                        fetch("/tncms/auth/webauthn/login/", {
                                method: "POST",
                                credentials: "include",
                                mode: "cors"
                            })
                            .then(function(resp) {
                                return resp.json();
                            })
                            .then(function(resp) {
                                return hankoWebAuthn.get(resp.options);
                            })
                            .then(function(resp) {
                                fetch("/tncms/auth/webauthn/login/complete/", {
                                        method: "POST",
                                        credentials: "include",
                                        mode: "cors",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(resp)
                                    })
                                    .then(function(resp) {
                                        return resp.json();
                                    })
                                    .then(function(resp) {
                                        btn.disabled = false;
                                        
                                        // Go to referer
                                        refererRedirect();
                                    })
                                    .catch(function(error) {
                                        btn.disabled = false;
                                        return;
                                    });
                            })
                            .catch(function(error) {
                                btn.disabled = false;
                                return;
                            });
                    });
                    
                    // Reveal webauthn UI
                    webauthUI.forEach(function(ui) {
                        ui.classList.remove('hidden');
                    });
                }
            }
            
            /** Referer */
            function refererRedirect() {
                const url = w.location,
                      queryString = url.search,
                      refererParam = new URLSearchParams(queryString).get('referer_url');
                
                var referer = encodeURI(refererParam);
                
                if(refererParam === null) {
                    if(url.pathname == '/users/login/') {
                        w.location = '/';
                    } else {
                        w.location.reload();
                    }
                } else {
                    if (!referer.includes(w.location.host)) {
                        w.location = (w.location.protocol + '//' + w.location.host + referer);
                    } else {
                        w.location = referer;
                    }
                }
            }
        }
    }
    
    /** Initialize */
    if (d.readyState == "loading") {
        d.onreadystatechange = function () {
            if (d.readyState == "complete") {
                webauthn.init();
            }
        }
    } else {
        webauthn.init();
    }
})(window, document);